
/**
 * @author José Luis R. <jose.ruiz@jbge.com.mx>
 * All process numbers listed.
 * Constants available to used for process identification and/or comparation
 */

const VC_PROCESS_NUMBER = 1.1
const VACO_PROCESS_NUMBER = 1.2
const LV_PROCESS_NUMBER = 1.3
const VR_PROCESS_NUMBER = 1.4
const SM_PROCESS_NUMBER = 2.1
const PT_PROCESS_NUMBER = 2.2
const ES_PROCESS_NUMBER = 2.3
const CP_PROCESS_NUMBER = 2.4
const ADO_PROCESS_NUMBER = 3.1
const GF_PROCESS_NUMBER = 4.1
const EF_PROCESS_NUMBER = 4.2
const PC_PROCESS_NUMBER = 5.1
const CO_PROCESS_NUMBER = 6.1

export {
  VC_PROCESS_NUMBER,
  VACO_PROCESS_NUMBER,
  LV_PROCESS_NUMBER,
  VR_PROCESS_NUMBER,
  SM_PROCESS_NUMBER,
  PT_PROCESS_NUMBER,
  ES_PROCESS_NUMBER,
  CP_PROCESS_NUMBER,
  ADO_PROCESS_NUMBER,
  GF_PROCESS_NUMBER,
  EF_PROCESS_NUMBER,
  PC_PROCESS_NUMBER,
  CO_PROCESS_NUMBER
}



// WEBPACK FOOTER //
// ./src/utils/ProcessNumbersConst.js